import { Component, OnInit, Output, EventEmitter, isDevMode } from '@angular/core';
import { Router }   from '@angular/router';
import { Admin } from '../common/modules/admin/models/Admin';
import { AdminService } from '../common/modules/admin/services/AdminService';
import { LocalNetworkService } from '../common/modules/core/services/LocalNetworkService';

import '../styles.sass';

@Component({
	selector: 	'my-app',
	template: 	require('./AppComponent.html'),
    styles: [require('./AppComponent.sass')]

})
export class AppComponent {
	private hostName: string;
	private module: string;
    private adminData: Admin;
	private redirectUrl: string = '/navigate';
	// Detect show/hide sidebar
	private toggleSidebar: boolean = false;
	
	constructor(
		protected router: Router,
        protected adminService: AdminService,
		protected localNetworkService: LocalNetworkService
		
	) {
		this.module = 'auth';
	}

	ngOnInit() {
		// Get hostname
		this.hostName = window.location.hostname;
		// this.getLocal();
		// Detect route to show sidebar
		this.toggleSidebar = this.router.url == '/navigate' ? false : true;
    }

	// Detect local or public network
	protected getLocal() {
        this.localNetworkService.getLocalNetWork()
            .subscribe(
                (result) => {
					this.adminData = this.adminService.getAdminSessionData();
					this.redirect(this.redirectUrl)
                },
				(err) => {
					if(this.adminData) {
						this.redirect(this.redirectUrl)
					}
				}
            )
    }
	
	// Redirect function
	protected redirect(redirectUrl: string) {
        this.router.navigate([redirectUrl]);
    }
}


// WEBPACK FOOTER //
// ./src/auth/AppComponent.ts